// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__sSbvb","skeleton-animation":"styles_skeleton-animation__2cZZd"};